import * as Handlebars from 'handlebars';

const operators: { [operator: string]: (l: any, r: any) => boolean } = {
    "==": (l: any, r: any) => l == r,
    "===": (l: any, r: any) => l === r,
    "!=": (l: any, r: any) => l != r,
    "!==": (l: any, r: any) => l !== r,
    "<": (l: any, r: any) => l < r,
    "<=": (l: any, r: any) => l <= r,
    ">": (l: any, r: any) => l > r,
    ">=": (l: any, r: any) => l >= r,
    "&&": (l: any, r: any) => l && r,
    "||": (l: any, r: any) => l || r
}

const ifCond: Handlebars.HelperDelegate = function (this: any, v1: any, operator: string, v2: any, options: Handlebars.HelperOptions): any {
    if (Object.prototype.hasOwnProperty.call(operators, operator))
        return operators[operator](v1, v2) ? options.fn(this) : options.inverse(this);

    return options.inverse(this);
};

export default ifCond;
